import { render, staticRenderFns } from "./TheBreadcrumb.vue?vue&type=template&id=524a1a5f&"
import script from "./TheBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./TheBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports